import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { RoundButton } from '@/components/UI/RoundButton';
import s from './index.module.scss';

const ConfirmModal = ({ title, desc, acceptLabel, cancelLabel, onDelete, onConfirm, onClose }) => {
  const { t } = useTranslation('modal');
  return (
    <div className={s.wrapper}>
      <div className={classnames(s.title, 'f-h2 f-500')}>{title}</div>
      <div className={classnames(s.desc, 'f-body')}>{desc}</div>
      <div className={s.controls}>
        {onConfirm && (
          <RoundButton
            className={classnames(s.button_confirm, 'hov')}
            type="button"
            label={acceptLabel || t('confirm_modal.confirm')}
            onClick={onConfirm}
            fullWidth
          />
        )}
        <RoundButton
          className={classnames(s.button_cancel, 'hov')}
          type="button"
          label={cancelLabel || t('confirm_modal.cancel')}
          onClick={onClose}
          fullWidth
        />
        {onDelete && (
          <RoundButton
            className={classnames(s.button_delete, 'hov')}
            type="button"
            label={t('confirm_modal.delete')}
            onClick={onDelete}
            fullWidth
          />
        )}
      </div>
    </div>
  );
};

export default ConfirmModal;
